import { ActionTree } from 'vuex'
import StateRun from './types'

const actions = {
} as ActionTree<StateRun, any>

export default actions
